'use client'

import React, { Dispatch, SetStateAction } from 'react'
import { ErrorType } from '@/types/errors.types'
import { ModalState, PartialModalState, SetErrorModalT } from '@/types/ModalProvider.types'
import { defaultState } from '@/config/modal.config'

export type ModalContextProps = {
  setErrorType: (arg: ErrorType | null) => void
  setErrorMessage: (arg: string) => void
  setError: (arg: Error) => void

  setErrorModal: SetErrorModalT

  modalState: ModalState
  setModalState: Dispatch<SetStateAction<ModalState>>
  updateModalState: (nextState: PartialModalState) => void
}

export const defaultContext: ModalContextProps = {
  setErrorType: (): void => undefined,
  setErrorMessage: (): void => undefined,
  setError: (): void => undefined,
  setErrorModal: (): void => undefined,

  modalState: defaultState,
  setModalState: (): void => undefined,
  updateModalState: (): void => undefined,
}

const ModalContext = React.createContext<ModalContextProps>(defaultContext)

export default ModalContext
